import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';

// NOT_IN_USE_CURRENTLY
@Component({
    selector: 'bm-contract-planned-amount-trace',
    templateUrl: 'bm-contract-planned-amount-trace.component.html',
    standalone: false
})
export class BmContractPlannedAmountTraceComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
